import { create } from "zustand";


type State = {
  currentProduct: any | null,
  setCurrentVariableProduct: (product: any | null) => void,
}

export const useProductVariableStore = create<State>(
  (set, get) => ({
    currentProduct: null,
    setCurrentVariableProduct: (product: any | null) => set({ currentProduct: product })
  })
);
